import { ConfirmedRequestedGroupMemberTripsFragment } from "generated/graphql";
import { groupBy, orderBy } from "lodash";

export type SortedBookedGroupMembersByOrder = {
    [key: string]: ConfirmedRequestedGroupMemberTripsFragment[];
};

export const getSortedGroupedBookedGroupMembers = (
    trips: Partial<ConfirmedRequestedGroupMemberTripsFragment>[] | undefined,
    sortAscending: boolean = true,
) => {
    const orders = (sortAscending: boolean) => {
        if (trips?.length) {
            const sortedGroupMembers = orderBy(
                trips,
                (trip) => trip.customer?.lastName?.toLowerCase(),
                sortAscending ? "asc" : "desc",
            );
            const sortedPrimaries = orderBy(
                sortedGroupMembers,
                (trip) => trip.isPrimary,
                "desc",
            );
            const groupedOrders = groupBy(sortedPrimaries, "booking._id");

            return Object.values(groupedOrders);
        }
    };

    return (orders(sortAscending) ?? [])
        .map((group) =>
            group.filter(
                (item): item is ConfirmedRequestedGroupMemberTripsFragment =>
                    item._id !== undefined,
            ),
        )
        .filter((group) => group.length > 0);
};
